export const TEAK_TYPE_NAMES = {
	DESK: 'TeakTypeWorkplace',
	ROOM: 'TeakTypeMeetingRoom',
	PARKING: 'TeakTypeParkingSpace',
	CUSTOM: 'TeakTypeCustom',
};

export const TEAK_TYPE_TO_ENTITY = {
	TeakTypeWorkplace: 'TeakEntityWorkplace',
	TeakTypeMeetingRoom: 'TeakEntityMeetingRoom',
	TeakTypeParkingSpace: 'TeakEntityParkingSpace',
	TeakTypeCustom: 'TeakEntityCustom',
};

export const TEAK_ENTITY_TO_TYPE = {
	TeakEntityWorkplace: 'TeakTypeWorkplace',
	TeakEntityMeetingRoom: 'TeakTypeMeetingRoom',
	TeakEntityParkingSpace: 'TeakTypeParkingSpace',
	TeakEntityCustom: 'TeakTypeCustom',
};

export const DEFAULT_TEAK_TYPES = ['TeakTypeWorkplace', 'TeakTypeMeetingRoom', 'TeakTypeParkingSpace'];
export const DEFAULT_TEAK_ENTITY_TYPES = ['TeakEntityWorkplace', 'TeakEntityMeetingRoom', 'TeakEntityParkingSpace'];
